import React, { useEffect } from 'react';

import {
  useRoleFormState,
  useRoleFormActions,
} from './RoleFormContext';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const RoleForm = ({ role, onSubmit, onCancel }) => {
  const state = useRoleFormState();
  const {
    initializeState,
    updateForm,
    updateGroupId,
    updateRoleName,
    onResponse,
    onError,
  } = useRoleFormActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  useEffect(() => {
    if (role) {
      updateForm(role);
    } else {
      initializeState();
    }
  }, []);

  const handleSubmit = () => {
    onSubmit({
      role,
      onResponse,
      onError,
      body: {
        roleForm: state?.roleForm,
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Group Id" id="groupId">
        <Input
          type="text"
          value={state?.roleForm?.groupId || ''}
          onChange={(e) => updateGroupId(e.target.value)}
        />
      </Field>

      <Field label="Role Name" id="roleName">
        <Input
          type="text"
          value={state?.roleForm?.roleName || ''}
          onChange={(e) => updateRoleName(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              if (onCancel) {
                onCancel();
              }
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            {!!role ? 'Update Role' : 'Create Role'}
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default RoleForm;
